import type { ReactNode } from 'react';

import styles from '@/admin/components/AdminButton.module.scss';

type AdminButtonProps = {
  children: ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  tone?: 'primary' | 'ghost' | 'danger';
  size?: 'md' | 'sm';
  disabled?: boolean;
  title?: string;
  'aria-label'?: string;
};

const TONE_CLASS = {
  primary: styles.primary,
  ghost: styles.ghost,
  danger: styles.danger,
};

export const AdminButton = ({
  children,
  onClick,
  type = 'button',
  tone = 'ghost',
  size = 'md',
  disabled,
  title,
  'aria-label': ariaLabel,
}: AdminButtonProps) => (
  <button
    type={type}
    className={`${styles.button} ${TONE_CLASS[tone]} ${size === 'sm' ? styles.sm : ''}`}
    onClick={onClick}
    disabled={disabled}
    title={title}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);
